<div class="package__list-container" [ngClass]="promoType() === 'bundling4G' ? 'grid-cols-1' : 'grid-cols-2'">
    @if (promoType() === 'poin') {
        @for(item of poinSliced(); track $index){
            <app-poin-card (click)="onClickPoin(item)" (keydown)="onClickPoin(item)" [data]="item" />
        }
    }@else if (promoType() === 'bundling4G') {
        @for (package of packageSliced(); track $index) {
            <div class="voucher_-">
                <voucher-card [data]="package" />
            </div>
        }
    }@else {
        @for(package of packageSliced(); track $index){
            <app-package-card (click)="onClickPackage(package)" (keydown)="onClickPackage(package)" [isAffiliatePackage]="isAffiliatePackage()" [data]="package" />
        }
    }
</div>

@if(data().packages.length > packageSliced().length || data().poins.length > poinSliced().length){
<div class="button__wrap">
    <button (click)="hasMorePackages ? onClickShowMore(): onClickShowLess()" class="more__button">{{hasMorePackages ?
        ('packageList.button.showMore' | translate): ('packageList.button.showLess' | translate) }}</button>
</div>
}
